<script setup>
name: 'blogPage'
const route = useRoute()
const { getBlogSettings, getBlogHome, getPosts } = useBlogData()
const { setPageHead } = useGlobalFeaturesData();

definePageMeta({
  layout: "blog",
});

// Temporary geetting the first page created
const { data: settings, error: settingsError } = await getBlogSettings();

const { data, error } = await getBlogHome(route.params.slug);
if (error.value) {
  throw createError({ statusCode: 404, statusMessage: error.value })
}

// Default sort of posts
let paramsString = '?sort=publishedAt:DESC&pagination[page]=1&pagination[pageSize]=7&pagination[withCount]=true'
// Adjusts posts to get the first one on top and pass others to reel
const { data: postsReel, error: postsError } = await getPosts(paramsString)

// On this page we get the first posts so it is on the bigger section with the featured posts on the side
let postsArr = postsReel.value.data
let firstPost = postsArr[0]
postsArr = postsArr.slice(1)

// Sections dynamic builder variable
const sections = data.value && data.value.blocks ? data.value.blocks : []
// Jump to top option
const displayJumpToTop = data.value.jumpToTop;

// Set meta tags in head for SEO
if (data.value && data.value.seo) {
  setPageHead(data.value.seo, route.path);
}
</script>

<template>
  <BlogCategories />
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 v-html="data.title"></h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-8">
        <BlogPostPreview class="featured-post" :post="firstPost" />
      </div>
      <div class="col-12 col-lg-4 d-none d-lg-block">
        <BlogPostFeatured :featuredPosts="settings.featuredPosts"/>
      </div>
    </div>
  </div>
  <section class="blog-reel">
    <ClientOnly>
      <BlogPostsReel :posts="postsArr" :meta="postsReel.meta" :nextItem="7"/>
    </ClientOnly>
  </section>
  <LayoutDynamicComponents v-if="sections" :sections="sections" />
  <section class="col-12 d-lg-none">
    <BlogPostFeatured :featuredPosts="settings.featuredPosts"/>
  </section>
  <LayoutBackToTop v-if="displayJumpToTop" />
</template>

<style lang="scss">
.blog-reel{
  padding-bottom: 40px;
}
@include media-breakpoint-up(lg){
  .blog-reel{
    padding-top: 40px;
  }
}
</style>